import React, { FunctionComponent, Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';
import ClientInfoSkeleton from '@components/Home/Skeleton/ClientInfoSkeleton';
import GroupListSkeleton from '@components/Home/Skeleton/GroupListSkeleton';
import InvestSummarySkeleton from '@components/Home/Skeleton/InvestSummarySkeleton';

const ClientInfo = lazy(() => import('@components/Home/ClientInfo'));
const InvestSummary = lazy(() => import('@components/Home/InvestSummary'));
const GroupList = lazy(() => import('@components/Home/GroupList'));

/** 메인 컴포넌트 */
const Home: FunctionComponent = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense fallback={<ClientInfoSkeleton />}>
          <ClientInfo />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<InvestSummarySkeleton />}>
          <InvestSummary />
        </Suspense>
      </ApiErrorBoundary>

      <ApiErrorBoundary>
        <Suspense fallback={<GroupListSkeleton />}>
          <GroupList title="조합 목록" />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default Home;
